import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const StatsSection = () => {
  return (
    <section id="stats-section" className="py-20 bg-surface">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Additional Trust Indicators */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="bg-white rounded-2xl p-8 shadow-professional"
        >
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div className="space-y-3">
              <Icon name="Shield" size={40} className="text-trust-builder mx-auto" />
              <h4 className="font-semibold text-text-primary">Zertifizierte Anwälte</h4>
              <p className="text-sm text-text-secondary">
                Alle Berater sind zugelassene Rechtsanwälte mit langjähriger Erfahrung
              </p>
            </div>

            <div className="space-y-3">
              <Icon name="Lock" size={40} className="text-primary mx-auto" />
              <h4 className="font-semibold text-text-primary">100% Vertraulich</h4>
              <p className="text-sm text-text-secondary">
                Anwaltliche Schweigepflicht und DSGVO-konforme Datenverarbeitung garantieren absolute Vertraulichkeit.
              </p>
            </div>

            <div className="space-y-3">
              <Icon name="Zap" size={40} className="text-conversion-accent mx-auto" />
              <h4 className="font-semibold text-text-primary">Sofortige Verfügbarkeit</h4>
              <p className="text-sm text-text-secondary">
                24/7 für Sie erreichbar – auch bei dringenden Rechtsfragen.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default StatsSection;